<div *ngIf="planType === 'planAvailable'">
    <app-gdo-subscription-detail-webview [termsAndCondition]="termsAndCondition"
      [termsAndConditionStatus]="termsAndConditionStatus" [acctDetail]="acctDetail" [selectedSP]="selectedSP">
    </app-gdo-subscription-detail-webview>
    <!-- <p>plan available</p> -->
  </div>
  
  <div *ngIf="planType === 'noPlanAvailable'">
    <!-- <app-my-wehicle-trials-web-view [planStatus]="planStatus" [termsAndCondition]="termsAndCondition"
      [termsAndConditionStatus]="termsAndConditionStatus" [selectedSP]="selectedSP"></app-my-wehicle-trials-web-view> -->
      <!-- <p>plan not available</p> -->
  </div>
  
  <div *ngIf="planType === 'loading'">
    <div class="background"></div>
  </div>